import { GET_ROLE, GET_TOKEN, SET_ROLE, SET_TOKEN } from "redux/TypeConstant"

const RoleReducer=(state=localStorage.getItem('role'),action)=>{
    switch(action.type)
    {
        case SET_ROLE:
        return state = action.data

        case GET_ROLE:
            return state 

            default :
            return state
    }

}

export default RoleReducer